import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ColorsConst, UtilsService } from 'src/app/core';

@Component({
  selector: 'app-wide-card',
  templateUrl: './wide-card.component.html',
  styleUrls: ['./wide-card.component.less'],
})
export class WideCardComponent implements OnInit {
  @Input() avatarNzShape: 'circle' | 'square' = 'circle';
  @Input() avatarNzIcon: string;
  @Input() avatarImg: string;
  @Input() avatarIconColorhex: string;
  @Input() avatarIconBgColorhex: string = ColorsConst.white;
  @Input() title: string;
  @Input() description: string;
  @Input() tagText: string;
  @Input() tagNzColor: string;

  constructor() {}

  ngOnInit(): void {}
}
